import { render, staticRenderFns } from "./form_service.vue?vue&type=template&id=20e08f45&scoped=true&"
import script from "./form_service.vue?vue&type=script&lang=js&"
export * from "./form_service.vue?vue&type=script&lang=js&"
import style0 from "./form_service.vue?vue&type=style&index=0&id=20e08f45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e08f45",
  null
  
)

export default component.exports